import { v4 as uuidv4 } from "uuid";
import { firebase } from "../firebase/firebase";
import { syncFail, syncingStart, syncSuccess } from "./ui";
import { updateDatabase } from "../utils/firebaseToState";
import {
  archiveNoteToDatabase,
  clearTrash,
  deleteNotePremenantlyFromDatabase,
  restoreNoteFromDatabase,
  saveNoteToDatabase,
  trashNote,
  unArchiveNoteToDatabase,
  updateNoteToDatabase,
} from "../functions/saveNoteToDatabase";
import { idomDBInstance } from "../axios-notes";
import { parseNoteCheckboxFields } from "../utils/helper";

// ************************************** ADD NOTE ************************************

export const addNoteSync = (note, id) => ({
  type: "ADD",
  note: { ...note, id, type: "note" },
});

export const addNote = (note) => {
  return async (dispatch, getState) => {
    try {
      let saveData = await saveNoteToDatabase(note);
      dispatch(addNoteSync(note, saveData.data.noteId));
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

export const addListSync = (list) => ({
  type: "ADD_LIST",
  list: { ...list, id: uuidv4() },
});

export const addList = (list) => {
  return async (dispatch, getState) => {
    dispatch(addListSync(list));
    try {
      await saveNoteToDatabase(list);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

// ************************************** ADD NOTE ENDS ************************************

// ************************************** DELETE NOTE ************************************

export const deleteNoteSync = (id) => ({ type: "DELETE", id: id });

export const deleteNote = (id) => {
  return async (dispatch, getState) => {
    dispatch(deleteNoteSync(id));
    try {
      await trashNote(id);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

// ************************************** DELETE NOTE ENDS ************************************

// ************************************** DELETE NOTE PERMANENTLY ************************************

export const deleteNotePermanentlySync = (id) => ({
  type: "DELETE_PERMANENTLY",
  id: id,
});

export const deleteNotePermanently = (id) => {
  return async (dispatch, getState) => {
    dispatch(deleteNotePermanentlySync(id));
    try {
      await deleteNotePremenantlyFromDatabase(id);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

// ************************************** DELETE NOTE PERMANENTLY ENDS ************************************

// ************************************** EDIT NOTE ************************************

export const editNoteSync = (id, note) => ({
  type: "EDIT",
  note: note,
  id: id,
});

export const editNote = (id, note) => {
  return async (dispatch, getState) => {
    console.log("note", note);
    dispatch(editNoteSync(id, note));

    try {
      await updateNoteToDatabase(note);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

// ************************************** EDIT NOTE ************************************

// ************************************** ARCHIVE NOTE ************************************

export const archiveNoteSync = (note) => ({ type: "ARCHIVE", note: note });

export const archiveNote = (note) => {
  return async (dispatch, getState) => {
    dispatch(archiveNoteSync(note));
    try {
      await archiveNoteToDatabase(note);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

// ************************************** ARCHIVE NOTE ENDS ************************************

export const archiveDirectlySync = (note) => ({
  type: "ARCHIVE_DIRECTLY",
  note: { ...note, id: uuidv4() },
});

export const archiveDirectly = (note) => {
  return (dispatch, getState) => {
    dispatch(archiveDirectlySync(note));
    console.log("fata", note);
    // updateDatabase(
    //   dispatch,
    //   getState,
    //   syncingStart,
    //   syncSuccess,
    //   syncFail,
    //   firebase
    // );
  };
};

export const editAndArchiveSync = (oldNote, newNote) => ({
  type: "EDIT_AND_ARCHIVE",
  oldNote: oldNote,
  newNote: newNote,
});

export const editAndArchive = (oldNote, newNote) => {
  return (dispatch, getState) => {
    dispatch(editAndArchiveSync(oldNote, newNote));
    updateDatabase(
      dispatch,
      getState,
      syncingStart,
      syncSuccess,
      syncFail,
      firebase
    );
  };
};

export const editAndUnarchiveSync = (oldNote, newNote) => ({
  type: "EDIT_AND_UNARCHIVE",
  oldNote: oldNote,
  newNote: newNote,
});

export const editAndUnarchive = (oldNote, newNote) => {
  return (dispatch, getState) => {
    dispatch(editAndUnarchiveSync(oldNote, newNote));
    updateDatabase(
      dispatch,
      getState,
      syncingStart,
      syncSuccess,
      syncFail,
      firebase
    );
  };
};

// ************************************** UNARCHIVE NOTE ************************************

export const unarchiveNoteSync = (note) => ({ type: "UNARCHIVE", note: note });

export const unarchiveNote = (note) => {
  return async (dispatch, getState) => {
    dispatch(unarchiveNoteSync(note));
    try {
      await unArchiveNoteToDatabase(note);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

// ************************************** UNARCHIVE NOTE ENDS ************************************

export const restoreNoteSync = (id) => ({ type: "RESTORE", id: id });

export const restoreNote = (id) => {
  return async (dispatch, getState) => {
    dispatch(restoreNoteSync(id));
    console.log("restoreNote", id);
    try {
      await restoreNoteFromDatabase(id);
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

export const emptyTrashSync = () => ({ type: "EMPTY_TRASH" });

export const emptyTrash = () => {
  return async (dispatch, getState) => {
    dispatch(emptyTrashSync());
    try {
      await clearTrash();
      dispatch(syncSuccess());
    } catch (error) {
      console.error("Failed to sync note:", error);
      dispatch(syncFail(error.message));
    }
  };
};

export const addNewLabelSync = (label) => ({
  type: "ADD_NEW_LABEL",
  label: label,
});

export const addNewLabel = (label) => {
  return (dispatch, getState) => {
    dispatch(addNewLabelSync(label));
    updateDatabase(
      dispatch,
      getState,
      syncingStart,
      syncSuccess,
      syncFail,
      firebase
    );
  };
};

//Deletes a label completely, from all notes, all trash notes, and from labels list
export const deleteLabelCompletelySync = (label) => ({
  type: "DELETE_LABEL_COMPLETELY",
  label: label,
});

export const deleteLabelCompletely = (label) => {
  return (dispatch, getState) => {
    dispatch(deleteLabelCompletelySync(label));
    updateDatabase(
      dispatch,
      getState,
      syncingStart,
      syncSuccess,
      syncFail,
      firebase
    );
  };
};

export const editLabelSync = (oldLabel, newLabel) => ({
  type: "EDIT_LABEL",
  oldLabel: oldLabel,
  newLabel: newLabel,
});

export const editLabel = (oldLabel, newLabel) => {
  return (dispatch, getState) => {
    dispatch(editLabelSync(oldLabel, newLabel));
    updateDatabase(
      dispatch,
      getState,
      syncingStart,
      syncSuccess,
      syncFail,
      firebase
    );
  };
};

// export const listItemCheckedToggle = (noteId, listItem, checked) => ({type: "LIST_ITEM_CHECKED_TOGGLE", noteId: noteId, listItem: listItem, checked: checked});

export const setMainState = (state) => ({ type: "SET_MAIN_STATE", state });

//Enden up not using, keep for reference
// export const startInitNotes = () => {
//   return (dispatch) => {
//     axios.get("/state.json").then((response) => {
//       const state = createState(response.data);
//       dispatch(setMainState(state));
//     });
//   };
// };
